import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { sendUserPassword } from '../utils/sendUserPassword'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUserPasswordMutation = () => {
  return useMutation({
    mutationFn: (email: string) => sendUserPassword(email),
    onSuccess: (message) => {
      toast.success(message || 'Email sent successfully.')
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Error sending email.')
    },
  })
}
